import { useBreakpointValue } from "@chakra-ui/react"

const useDevice = () => {
  const device = useBreakpointValue({ base: "tablet", desktop: "desktop" });
  return device;
}

export default useDevice;
